// Api
import { apiGetTutorials } from '@/services/API/tutorials'

// Components
import maModal from '@/components/modal'

/**
 * @module
 * @name Tutorials
 * @description Displays the tutorials to use the app
 */
export default {
  name: 'Tutorials',
  components: {
    maModal
  },

  /**
  * @property {Array} tutorialsData List of all the tutorials that come from the api
  * @property {String} titleVideo Title of the tutorial that is clicked and used in the modal
  * @property {String} urlVideo Url of the tutorial that is clicked and used in the modal for the video source
  */

  data: function () {
    return {
      tutorialsData: [],
      titleVideo: '',
      urlVideo: ''
    }
  },
  methods: {
    /**
   * @Function
   * @name handleOpenModal
   * @param {String} urlTutorial Url of the tutorial that is clicked
   * @param {String} titleTutorial Title of the tutorial that is clicked
   * @description Opens modal and sets the title of the video of the modal and the url of the video
   */
    handleOpenModal (urlTutorial, titleTutorial) {
      this.$refs.videoModal.showModal = true
      this.titleVideo = titleTutorial
      this.urlVideo = urlTutorial
    },

    /**
   * @Function
   * @name getDataTutorials
   * @description Calls the api to get the tutorials and fills the property tutorialsData
   */
    getDataTutorials () {
      apiGetTutorials().then(res => {
        this.tutorialsData = res
      }).catch((err) => {
        const errs = [400, 500, 409]
        const errCode = errs.find(errCode => err.response.status === errCode) || 0
        this.throwNotification(this.$t(`notifications.error.${errCode}.title`), this.$t(`notifications.error.${errCode}.body`), 'KO')
      })
    }
  },

  /**
   * @function
   * @name mounted
   * @description Gets the data for the tutorials
   */
  mounted () {
    this.getDataTutorials()
  }
}
